import {
  getDocs,
  limit,
  onSnapshot,
  query,
  startAfter,
} from "firebase/firestore";
import { useState } from "react";
import { DEFAULT_LIMIT } from "../../constants/webapp";

export function getDefaultLimit() {
  return limit(DEFAULT_LIMIT);
}

export function usePagination(docRef) {
  const [paginatedList, setList] = useState([]);
  const [lastDoc, setLastDoc] = useState();
  const [loading, setLoading] = useState(false);

  const getList = () => {
    setLoading(true);
    onSnapshot(docRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id, // map document id
        docRef: doc.ref,
      }));
      // set collection data
      setList(data);
      const lastDoc = snapshot.docs[snapshot.docs.length - 1]; // get snapshot of last document
      setLastDoc(lastDoc);
      setLoading(false);
    });
  };

  // update current paginated list
  const updateState = (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id, // map document id
      docRef: doc.ref,
    }));
    // append to list
    setList((prev) => [...prev, ...data]);
    const lastDoc = snapshot.docs[snapshot.docs.length - 1]; // get snapshot of last document
    setLastDoc(lastDoc);
  };

  // get more documents
  const fetchMore = () => {
    if (lastDoc) {
      setLoading(true);
      getDocs(query(docRef, startAfter(lastDoc))).then((snapshot) => {
        updateState(snapshot);
        setLoading(false);
      });
    }
  };

  return { fetchMore, paginatedList, setList, getList, loading };
}
